

const IconPlus = () => (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9232 5.38229H7.14519V1.60433C7.14519 0.147516 4.88592 0.147516 4.88592 1.60433V5.38229H1.10795C-0.348484 5.38229 -0.348484 7.64157 1.10795 7.64157H4.88592V11.4195C4.88592 12.8763 7.14519 12.8763 7.14519 11.4195V7.64157H10.9232C12.3798 7.64157 12.3798 5.38229 10.9232 5.38229Z" fill="#FBFBFB"/>
    </svg>
);
export default IconPlus;